<template>
    <div class="mt-6">
        <div class="dark:text-white">
            Parâmetros para cálculos da velocidade dos produtos:
        </div>
        
        <!-- Receita -->
        <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4" colspan="4">
                            <p class="flex items-center">
                                Faturamento
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.positive_effect"
                                />
                            </p>
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Referência de Baixa Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_minimum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Referência de Alta Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_maximum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Peso
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.weight"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Período
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.period"
                                />
                            </p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b border-gray-200 dark:border-gray-700">
                        <td scope="row" class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.revenue.min"
                                required
                                min="0"
                                max="2000000000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.revenue.max"
                                required
                                min="0"
                                max="2000000000"
                            />
                        </td>
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.revenue.weight"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.revenue.period"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <!-- Quantidade de Vendas -->
        <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4" colspan="4">
                            <p class="flex items-center">
                                Quantidade de Vendas
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.positive_effect"
                                />
                            </p>
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Referência de Baixa Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_minimum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Referência de Alta Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_maximum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Peso
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.weight"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Período
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.period"
                                />
                            </p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b border-gray-200 dark:border-gray-700 w-1/4">
                        <td scope="row" class="py-4 px-4 bg-gray-50 dark:bg-gray-800">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.sales_quantity.min"
                                required
                                min="0"
                                max="2000000000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.sales_quantity.max"
                                required
                                min="0"
                                max="2000000000"
                            />
                        </td>
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.sales_quantity.weight"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.sales_quantity.period"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <!-- Percentual de Conversão -->
        <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4" colspan="4">
                            <p class="flex items-center">
                                Percentual de Conversão
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.positive_effect"
                                />
                            </p>
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Referência de Baixa Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_minimum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Referência de Alta Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_maximum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800  w-1/4">
                            <p class="flex items-center">
                                Peso
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.weight"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Período
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.period"
                                />
                            </p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b border-gray-200 dark:border-gray-700">
                        <td scope="row" class="py-4 px-4 bg-gray-50 dark:bg-gray-800  w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.conversion_percentage.min"
                                required
                                min="0"
                                max="100"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.conversion_percentage.max"
                                required
                                min="0"
                                max="100"
                            />
                        </td>
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.conversion_percentage.weight"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.conversion_percentage.period"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <!-- Quantidade de Vendas de Afiliados -->
        <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4" colspan="4">
                            <p class="flex items-center">
                                Quantidade de Vendas de Afiliados
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.positive_effect"
                                />
                            </p>
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Referência de Baixa Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_minimum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Referência de Alta Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_maximum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-80 w-1/4">
                            <p class="flex items-center">
                                Peso
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.weight"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Período
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.period"
                                />
                            </p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b border-gray-200 dark:border-gray-700">
                        <td scope="row" class="py-4 px-4 bg-gray-50 dark:bg-gray-800  w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.affiliate_sales_quantity.min"
                                required
                                min="0"
                                max="2000000000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.affiliate_sales_quantity.max"
                                required
                                min="0"
                                max="2000000000"
                            />
                        </td>
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.affiliate_sales_quantity.weight"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.affiliate_sales_quantity.period"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <!-- Percentual de Reembolsos -->
        <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4" colspan="4">
                            <p class="flex items-center">
                                Percentual de Reembolso
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.negative_effect"
                                />
                            </p>
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Referência de Baixa Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_minimum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Referência de Alta Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_maximum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Peso
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.weight"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Período
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.period"
                                />
                            </p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b border-gray-200 dark:border-gray-700">
                        <td scope="row" class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.refund.max"
                                required
                                min="0"
                                max="100"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.refund.min"
                                required
                                min="0"
                                max="100"
                            />
                        </td>
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.refund.weight"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.refund.period"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <!-- Percentual de Chargebacks -->
        <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4" colspan="4">
                            <p class="flex items-center">
                                Percentual de Chargeback
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.negative_effect"
                                />
                            </p>
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Referência de Baixa Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_minimum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Referência de Alta Performance
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_maximum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <p class="flex items-center">
                                Peso
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.weight"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/4">
                            <p class="flex items-center">
                                Período
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.period"
                                />
                            </p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b border-gray-200 dark:border-gray-700">
                        <td scope="row" class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.chargeback.max"
                                required
                                min="0"
                                max="100"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.chargeback.min"
                                required
                                min="0"
                                max="100"
                            />
                        </td>
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.chargeback.weight"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.chargeback.period"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <!-- Dias desde o lançamento -->
        <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/4" colspan="4">
                            <p class="flex items-center">
                                Dias Desde o Lançamento
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.days_since_launch_effect"
                                />
                            </p>
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/3">
                            <p class="flex items-center">
                                Peso
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.weight"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/3">
                            <p class="flex items-center">
                                Período
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.days_since_launch"
                                />
                            </p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b border-gray-200 dark:border-gray-700">
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/3">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.days_since_launch.weight"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/3">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.days_since_launch.period"
                                required
                                min="0"
                                max="365"
                            />
                        </td>
                    </tr>
                </tbody>  
            </table>
        </div>
        
        <!-- Velocidades -->
        <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800" colspan="4">Configurações Gerais</th>
                    </tr>
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800 w-1/3">
                            <p class="flex items-center">
                                Velocidade Mínima
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_minimum"
                                />
                            </p>
                        </th>
                        <th scope="col" class="py-2 px-4 w-1/3">
                            <p class="flex items-center">
                                Velocidade Máxima
                                <ExclamationCircleIcon
                                    class="h-4 w-4 mr-1"
                                    aria-hidden="true"
                                    v-tooltip="tooltipText.reference_maximum"
                                />
                            </p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b border-gray-200 dark:border-gray-700">
                        <td scope="row" class="py-4 px-4 bg-gray-50 dark:bg-gray-800 w-1/3">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.speed.min"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                        <td class="py-4 px-4 w-1/3">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500"
                                type="number"
                                v-model="setting.speed.max"
                                required
                                min="0"
                                max="1000"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <button
            @click.prevent="update"
            :disabled="false"
            type="button"
                class="mr-2 inline-flex items-center px-10 py-2 h-10 font-semibold leading-6 text-sm shadow rounded-md text-white bg-indigo-500"
        >
            Salvar
        </button>

        <button
            @click.prevent="preview"
            :disabled="false"
            type="button"
                class="mr-2 inline-flex items-center px-10 py-2 h-10 font-semibold leading-6 text-sm shadow rounded-md text-white bg-indigo-500"
        >
            Pré-visualizar resultados
        </button>
        
        <!-- MODAL DE PREVIEW -->
        
        <div v-if="showPreviewModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-3/4 max-w-4xl">
                <div class="flex justify-between items-center p-4 border-b border-gray-300 dark:border-gray-700">
                    <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Pré-visualização dos Resultados</h3>
                    <button @click="closePreviewModal" class="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
                        <span class="sr-only">Fechar</span>
                        &times;
                    </button>
                </div>
                <div class="p-6 max-h-[70vh] overflow-y-auto">
                    <div v-if="loadingPreview" class="flex justify-center items-center">
                        <svg class="animate-spin h-8 w-8 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                        </svg>
                        <span>
                            O cálculo utiliza os dados em cache da última atualização da vitrine e pode levar até 2 minutos para ser concluído. Por favor, espere...
                        </span>
                    </div>
                    <div v-else>
                        <li v-for="item in previewData" :key="item.id" class="mb-8 w-full">
                            <div class="flex items-center gap-4 mb-4">
                                <img :src="item.cover_picture" alt="Capa do Produto" class="w-24 h-auto rounded" />
                                <h3 class="font-semibold text-xl">{{ item.name }} ({{ item.speedometer }} km/h)</h3>
                            </div>
                            <table class="w-full text-sm border-collapse">
                                <thead>
                                    <tr class="bg-gray-100 text-left">
                                        <th class="p-2 border">Indicador</th>
                                        <th class="p-2 border">Valor Considerado</th>
                                        <th class="p-2 border">Contribuição na Velocidade</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="p-2 border">Faturamento</td>
                                        <td class="p-2 border">R${{ item.calculation_settings.revenue.toFixed(2) }}</td>
                                        <td class="p-2 border">{{ item.calculation_settings.revenue_speed.toFixed(2) }} km/h</td>
                                    </tr>
                                    <tr>
                                        <td class="p-2 border">Quantidade de vendas</td>
                                        <td class="p-2 border">{{ item.calculation_settings.sales_quantity.toFixed(2) }}</td>
                                        <td class="p-2 border">{{ item.calculation_settings.sales_quantity_speed.toFixed(0) }} km/h</td>
                                    </tr>
                                    <tr>
                                        <td class="p-2 border">Percentual de conversão</td>
                                        <td class="p-2 border">{{ item.calculation_settings.conversion_rate.toFixed(2) }}%</td>
                                        <td class="p-2 border">{{ item.calculation_settings.conversion_rate_speed.toFixed(2) }} km/h</td>
                                    </tr>
                                    <tr>
                                        <td class="p-2 border">Quantidade de vendas de afiliados</td>
                                        <td class="p-2 border">{{ item.calculation_settings.affiliate_sales_quantity.toFixed(0) }}</td>
                                        <td class="p-2 border">{{ item.calculation_settings.affiliate_sales_speed.toFixed(2) }} km/h</td>
                                    </tr>
                                    <tr>
                                        <td class="p-2 border">Percentual de reembolso</td>
                                        <td class="p-2 border">{{ item.calculation_settings.refund.toFixed(2) }}%</td>
                                        <td class="p-2 border">{{ item.calculation_settings.refund_speed.toFixed(2) }} km/h</td>
                                    </tr>
                                    <tr>
                                        <td class="p-2 border">Percentual de chargeback</td>
                                        <td class="p-2 border">{{ item.calculation_settings.chargeback.toFixed(2) }}%</td>
                                        <td class="p-2 border">{{ item.calculation_settings.chargeback_speed.toFixed(2) }} km/h</td>
                                    </tr>
                                    <tr>
                                        <td class="p-2 border">Dias desde o lançamento</td>
                                        <td class="p-2 border">{{ item.calculation_settings.days_since_launch.toFixed(0) }} dias</td>
                                        <td class="p-2 border">{{ item.calculation_settings.days_since_launch_speed.toFixed(2) }} km/h</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                    </div>
                </div>
                <div class="flex justify-end p-4 border-t border-gray-300 dark:border-gray-700">
                    <button @click="closePreviewModal" class="px-4 py-2 bg-indigo-500 text-white rounded-md hover:bg-indigo-600">
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    


        <!-- Calculadora -->
        <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600 mt-16">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800" colspan="7">Calculadora Interativa de Velocidade (Divergências podem ser encontradas por problemas de arredondamento)</th>
                    </tr>
                    <tr>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800">
                            Faturamento
                        </th>
                        <th scope="col" class="py-2 px-4">
                            Qtd. de vendas
                        </th>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800">
                            Percentual de conversão
                        </th>
                        <th scope="col" class="py-2 px-4">
                            Qtd. de vendas de afiliados
                        </th>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800">
                            % Reembolso
                        </th>
                        <th scope="col" class="py-2 px-4">
                            % Chargeback
                        </th>
                        <th scope="col" class="py-2 px-4 bg-gray-50 dark:bg-gray-800">
                            Dias
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="border-b border-gray-200 dark:border-gray-700">
                        <th scope="row" class="py-4 px-4 bg-gray-50 dark:bg-gray-800">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500" type="number" v-model="calculator.revenue">
                        </th>
                        <td class="py-4 px-4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500" type="number" v-model="calculator.sales_quantity">  
                        </td>
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500" type="number" v-model="calculator.conversion_percentage">
                        </td>
                        <td class="py-4 px-4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500" type="number" v-model="calculator.affiliate_sales_quantity">
                        </td>
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500" type="number" v-model="calculator.refund">
                        </td>
                        <td class="py-4 px-4">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500" type="number" v-model="calculator.chargeback">
                        </td>
                        <td class="py-4 px-4 bg-gray-50 dark:bg-gray-800">
                            <input class="bg-transparent border-0 outline-none w-full border-b border-gray-500" type="number" v-model="calculator.days_since_launch">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div>  
            <h3 class="font-semibold text-center text-gray-800 mt-6">
                1ª Parte - Como funciona a normalização
            </h3>
            <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600" v-html="normalizacaoExemplo"></div>

            <h3 class="font-semibold text-center text-gray-800 mt-6">
                2ª Parte - O valor normalizado dos valores com base nas configurações (O valor de dias desde o lançamento não é normalizado pois funciona como um impulso)
            </h3>
            <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600" v-html="equacaoNormalizacao"></div>

            <h3 class="font-semibold text-center text-gray-800 mt-6">
                3ª Parte - A soma dos valores com seus respectivos pesos
            </h3>
            <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600" v-html="equacaoPesos"></div>

            <h3 class="font-semibold text-center text-gray-800 mt-6">
                4ª Parte - A velocidade final é determinada pelos limites configurados. Caso uma equação os ultrapasse, serão considerados os limites.
            </h3>
            <div class="overflow-x-auto relative shadow-md sm:rounded-lg my-4 border border-gray-600" v-html="theoricalEquation"></div>
        </div>
    </div>

</template>

<script>
import { ref, reactive, computed } from 'vue';
import VueSelect from "../../components/forms/VueSelect.vue";
import { useToast } from "vue-toastification";
import katex from "katex";
import "katex/dist/katex.min.css";
import {
    ExclamationCircleIcon,
} from "@heroicons/vue/24/outline";

export default {
    components: { VueSelect, ExclamationCircleIcon },
    setup() {
        const toast = useToast();
        const selected = ref(null);
        const loading = ref(false);
        const calculator = reactive({
            revenue: 0,
            sales_quantity: 0,
            conversion_percentage: 0,
            affiliate_sales_quantity: 0,
            refund: 0,
            chargeback: 0,
            days_since_launch: 0,
        });
        const setting = reactive({
            revenue: {
                min: 10000,
                max: 500000,
                weight: 20,
                period: 30,
            },
            sales_quantity: {
                min: 100,
                max: 5000,
                weight: 50,
                period: 30,
            },
            conversion_percentage: {
                min: 1,
                max: 6.5,
                weight: 10,
                period: 30,
            },
            affiliate_sales_quantity: {
                min: 10,
                max: 500,
                weight: 10,
                period: 30,
            },
            refund: {
                min: 1.5,
                max: 5,
                weight: 5,
                period: 30,
            },
            chargeback: {
                min: 0.5,
                max: 2.5,
                weight: 7,
                period: 30,
            },
            days_since_launch: {
                weight: 1,
                period: 30
            },
            speed: {
                min: 30,
                max: 240
            }
        });
        const showPreviewModal = ref(false);
        const loadingPreview = ref(false);
        const previewData = ref({});

        const tooltipText = {
            reference_minimum: "Referência para um valor considerado 'ruim'",
            reference_maximum: "Referência para um valor considerado 'excelente'",
            weight: "O peso que esse valor terá na equação de velocidade",
            period: "O período dos últimos X dias que serão considerados para os cálculos. Deixe 0 para ilimitado (Isso pode causar demoras no carregamento)",
            days_since_launch: "O período em que o produto é considerado novo e recebe um impulso a mais na velocidade",
            positive_effect: "Esse campo tem um efeito positivo na velocidade e quanto mais perto do máximo melhor",
            negative_effect: "Esse campo tem um efeito negativo na velocidade e quanto mais perto do mínimo melhor",
            days_since_launch_effect: "Esse campo tem efeito positivo, mas diminui conforme o tempo e é zerado após o período configurado",
        };

        const fetch = () => {
            loading.value = true;
            axios.get('/api/showcase/setting').then(({ data }) => {              
                Object.assign(setting, data.setting);
                loading.value = false;
            }).catch(({ response }) => {
                loading.value = false;
            });
        };

        const updateSetting = () => {
            axios.put('/api/showcase/setting', {
                setting: setting
            }).then(({ response }) => {
                toast.success("Configuração salva com sucesso!", { timeout: 2000 });
            }).catch(({ response }) => {
                response.data.errors.forEach(element => {
                    toast.error(element, { timeout: 3000 });
                });
            });
        };

        function validateSettings() {
            const isEmpty = (value) => value === null || value === undefined || value === '' || Number.isNaN(Number(value));

            const standardSettings = [
                    { key: 'revenue', name: 'faturamento' },
                    { key: 'sales_quantity', name: 'quantidade de vendas' },
                    { key: 'conversion_percentage', name: 'percentual de conversão', maxValue: 100 },
                    { key: 'affiliate_sales_quantity', name: 'quantidade de vendas de afiliados' },
                    { key: 'refund', name: 'percentual de reembolso', maxValue: 100, isNegative: true },
                    { key: 'chargeback', name: 'percentual de chargeback', maxValue: 100, isNegative: true },
                ];

            for (const { key, name, maxValue, isNegative } of standardSettings) {
                const current = setting[key];
                
                if (isEmpty(current.min) || isEmpty(current.max) || isEmpty(current.weight) || isEmpty(current.period)) {
                    toast.error(`Os campos de ${name} não podem estar vazios.`, { timeout: 5000 });
                    return false;
                }
                
                if (current.min < 0 || current.max < 0 || current.weight < 0) {
                    toast.error(`Os valores de ${name} não podem ser negativos.`, { timeout: 5000 });
                    return false;
                }
                
                if (current.period < 0 || current.period > 365) {
                    toast.error(`O período de ${name} deve estar entre 0 e 365 dias.`, { timeout: 5000 });
                    return false;
                }
                
                if (maxValue && (current.min > maxValue || current.max > maxValue)) {
                    toast.error(`Os valores de ${name} devem estar entre 0 e ${maxValue}.`, { timeout: 5000 });
                    return false;
                }
                
                if (isNegative) {
                    if (current.max < current.min) {
                        toast.error(`No caso de ${name}, a referência de baixa performance deve ser maior que a de alta performance.`, { timeout: 5000 });
                        return false;
                    }
                } else {
                    if (current.max < current.min) {
                        toast.error(`A referência de baixa performance de ${name} deve ser menor que a de alta performance.`, { timeout: 5000 });
                        return false;
                    }
                }
            }
            
            if (isEmpty(setting.days_since_launch.weight) || isEmpty(setting.days_since_launch.period)) {
                toast.error("Os campos de dias desde o lançamento não podem estar vazios.", { timeout: 5000 });
                return false;
            }
            
            if (setting.days_since_launch.weight < 0) {
                toast.error("O peso de dias desde o lançamento não pode ser negativo.", { timeout: 5000 });
                return false;
            }
            
            if (setting.days_since_launch.period < 1 || setting.days_since_launch.period > 365) {
                toast.error("O período de dias desde o lançamento deve estar entre 1 e 365 dias.", { timeout: 5000 });
                return false;
            }
            
            if (isEmpty(setting.speed.min) || isEmpty(setting.speed.max)) {
                toast.error("Os campos de velocidade não podem estar vazios.", { timeout: 5000 });
                return false;
            }
            
            if (setting.speed.min < 0 || setting.speed.max < 0) {
                toast.error("Os valores de velocidade não podem ser negativos.", { timeout: 5000 });
                return false;
            }
            
            if (setting.speed.max <= setting.speed.min) {
                toast.error("A velocidade máxima deve ser maior que a mínima.", { timeout: 5000 });
                return false;
            }
            
            return true;
        }

        const update = () => {
            if (!validateSettings()) {
                return;
            }

            updateSetting();
        };

        const preview = () => {
            if (!validateSettings()) {
                return;
            }

            showPreviewModal.value = true;
            loadingPreview.value = true;
            
            axios.post('/api/showcase/preview', {
                setting: setting
            }).then(( {data} ) => {
                console.log(data.preview);
                
                loadingPreview.value = false;
                previewData.value = data.preview.map(item => ({
                    ...item,
                    calculation_settings: JSON.parse(item.calculation_settings)
                }));

                
            }).catch((error) => {
                console.log(error);

                toast.error(error, { timeout: 3000 });
            });
        };

        const closePreviewModal = () => {
            showPreviewModal.value = false;
        }

        const normalizeValue = (value, min, max) => {
            // if (value < min) {
            //     return 0;
            // }

            return ((value - min) / (max - min)).toFixed(2);
        };

        const norm_revenue = computed(() => normalizeValue(calculator.revenue, setting.revenue.min, setting.revenue.max));
        const norm_sales_quantity = computed(() => normalizeValue(calculator.sales_quantity, setting.sales_quantity.min, setting.sales_quantity.max));
        const norm_conversion_percentage = computed(() => normalizeValue(calculator.conversion_percentage, setting.conversion_percentage.min, setting.conversion_percentage.max));
        const norm_affiliate_sales_quantity = computed(() => normalizeValue(calculator.affiliate_sales_quantity, setting.affiliate_sales_quantity.min, setting.affiliate_sales_quantity.max));
        const norm_refund = computed(() => normalizeValue(calculator.refund, setting.refund.min, setting.refund.max));
        const norm_chargeback = computed(() => normalizeValue(calculator.chargeback, setting.chargeback.min, setting.chargeback.max));
        const norm_days_since_launch = computed(() => {
            let value = 0;

            if (calculator.days_since_launch < setting.days_since_launch.period) {
                if (calculator.days_since_launch == 0) {
                    calculator.days_since_launch = 1;
                }

                value = (1 / calculator.days_since_launch) * setting.days_since_launch.weight;
            }

            return value;
        });
        const norm_result = computed(() => {
            return (norm_revenue.value * setting.revenue.weight
                + norm_sales_quantity.value * setting.sales_quantity.weight
                + norm_conversion_percentage.value * setting.conversion_percentage.weight
                + norm_affiliate_sales_quantity.value * setting.affiliate_sales_quantity.weight
                - norm_refund.value * setting.refund.weight
                - norm_chargeback.value * setting.chargeback.weight
                + norm_days_since_launch.value)/(theorical_maximum.value) * (setting.speed.max - setting.speed.min) + setting.speed.min;
        });
        const theorical_minimum = computed(() => {
            return - setting.refund.weight
                - setting.chargeback.weight;
        });
        const theorical_maximum = computed(() => {
            return setting.revenue.weight +
                setting.sales_quantity.weight +
                setting.conversion_percentage.weight +
                setting.affiliate_sales_quantity.weight +
                setting.days_since_launch.weight;
        });
        const speed = computed( () => {
            let value = normalizeValue(norm_result.value, theorical_minimum.value, theorical_maximum.value) * (setting.speed.max - setting.speed.min) + setting.speed.min;

            if(value > setting.speed.max) {
                value = setting.speed.max;
            } else if(value < setting.speed.min) {
                value = setting.speed.min;
            }

            return value;
        })

        const normalizacaoExemplo = computed(() =>
            katex.renderToString(
                `\\text{Normalização(Valor)} =
                \\frac{\\text{Valor} - \\text{Referência}_{\\min}}{\\text{Referência}_{\\max} - \\text{Referência}_{\\min}}
                `,
                { throwOnError: false, displayMode: true }
            )
        );

        const equacaoNormalizacao = computed(() =>
        katex.renderToString(
            `
            \\begin{aligned}
            \\text{Normalização(Faturamento)} &= \\frac{${calculator.revenue} - ${setting.revenue.min}}{${setting.revenue.max} - ${setting.revenue.min}} = ${norm_revenue.value} \\\\
            \\text{Normalização(Quantidade de Vendas)} &= \\frac{${calculator.sales_quantity} - ${setting.sales_quantity.min}}{${setting.sales_quantity.max} - ${setting.sales_quantity.min}} = ${norm_sales_quantity.value} \\\\
            \\text{Normalização(Percentual de Conversão)} &= \\frac{${calculator.conversion_percentage} - ${setting.conversion_percentage.min}}{${setting.conversion_percentage.max} - ${setting.conversion_percentage.min}} = ${norm_conversion_percentage.value} \\\\
            \\text{Normalização(Quantidade de Vendas de Afiliados)} &= \\frac{${calculator.affiliate_sales_quantity} - ${setting.affiliate_sales_quantity.min}}{${setting.affiliate_sales_quantity.max} - ${setting.affiliate_sales_quantity.min}} = ${norm_affiliate_sales_quantity.value} \\\\
            \\text{Normalização(Percentual de Reembolso)} &= \\frac{${calculator.refund} - ${setting.refund.min}}{${setting.refund.max} - ${setting.refund.min}} = ${norm_refund.value} \\\\
            \\text{Normalização(Percentual de Chargebacks)} &= \\frac{${calculator.chargeback} - ${setting.chargeback.min}}{${setting.chargeback.max} - ${setting.chargeback.min}} = ${norm_chargeback.value} \\\\
            \\text{Dias desde o lançamento} &= \\frac{1}{${calculator.days_since_launch}} = ${norm_days_since_launch.value}
            \\end{aligned}
            `,
            { throwOnError: false, displayMode: true }
        )
        );

        const equacaoPesos = computed(() => {
        const equacao = `
            \\text{Equação com os pesos} = \\\\[2ex]
            + (\\text{Normalização(Faturamento)} \\times \\text{Peso(Faturamento)}) \\\\
            + (\\text{Normalização(Quantidade de Vendas)} \\times \\text{Peso(Quantidade de Vendas)}) \\\\
            + (\\text{Normalização(Percentual de Conversão)} \\times \\text{Peso(Percentual de Conversão)}) \\\\
            + (\\text{Normalização(Quantidade de Vendas de Afiliados)} \\times \\text{Peso(Quantidade de Vendas de Afiliados)}) \\\\
            - (\\text{Normalização(Percentual de Reembolso)} \\times \\text{Peso(Percentual de Reembolso)}) \\\\
            - (\\text{Normalização(Percentual de Chargebacks)} \\times \\text{Peso(Percentual de Chargebacks)}) \\\\
            + (\\text{Normalização(Dias desde o lançamento)} \\times \\text{Peso(Dias desde o lançamento)}) \\\\[2ex] =

            
            (\\frac{(${norm_revenue.value} \\times ${setting.revenue.weight} )
            + (${norm_sales_quantity.value} \\times ${setting.sales_quantity.weight})
            + (${norm_conversion_percentage.value} \\times ${setting.conversion_percentage.weight} )
            + (${norm_affiliate_sales_quantity.value} \\times ${setting.affiliate_sales_quantity.weight} )
            - (${norm_refund.value} \\times ${setting.refund.weight} )
            - (${norm_chargeback.value} \\times ${setting.chargeback.weight})
            + (${norm_days_since_launch.value} \\times ${setting.days_since_launch.weight})}{${theorical_maximum.value}}) \\times (${setting.speed.max} - ${setting.speed.min}) + ${setting.speed.min} \\\\
            = ${norm_result.value}
        `;
            return katex.renderToString(equacao, { throwOnError: false, displayMode: true });
        });

        const theoricalEquation = computed(() => {
           
            const equacao = `
                \\begin{aligned}
                \\text{Velocidade} = ${speed.value}
                \\end{aligned}
            `;

            return katex.renderToString(equacao, { throwOnError: false, displayMode: true });
        });

    

        return {
            selected,
            loading,
            calculator,
            setting,
            fetch,
            update,
            toast,
            normalizacaoExemplo,
            equacaoNormalizacao,
            equacaoPesos,
            theoricalEquation,
            tooltipText,
            preview,
            showPreviewModal,
            loadingPreview,
            previewData,
            closePreviewModal
        };
    },
    mounted() {
        this.fetch();
    },
};
</script>